/**
 * Utility functions for DataTables styling and configuration
 */
export class DataTableUtils {
  /**
   * Applies consistent styling for DataTables to position "Show XX entries" at bottom left
   * and "X to XX of XXX entries" text at bottom right
   * 
   * This function can be called directly without requiring constructor injection
   * or component extension.
   * 
   * @example
   * // In a component:
   * this.dtOptions = {
   *   pagingType: 'full_numbers',
   *   pageLength: 10,
   *   // ...other options
   * };
   * this.dtOptions = DataTableUtils.applyStandardStyling(this.dtOptions);
   * 
   * @param options The original DataTable options
   * @returns DataTable options with standardized styling
   */
  public static applyStandardStyling(options: DataTables.Settings): DataTables.Settings {
    const styledOptions = { ...options };
    
    // Apply the custom DOM structure for proper positioning
    styledOptions.dom = 'rtp<"bottom"<"float-left"l><"float-right"i>>';
    
    // Format the info text without extra divs
    if (!styledOptions.language) {
      styledOptions.language = {};
    }
    styledOptions.language.info = '_START_ to _END_ of _TOTAL_ entries';
    
    return styledOptions;
  }
}